define('views/modules/member/member/edit/member-create-panel',[
    // Libs
    'underscore', 'utils',
    //services
    'services/events/user-events',
    'services/user',
    // collections
    'collections/member/groups',
    // views
    'views/parts/panel/base-panel',
    'views/modules/member/member/edit/member-create-content',
], function(
    // Libs
    _, U,
    //services
    UserEvents,
    User,
    // collections
    CGroups,
    // views
    VBasePanel,
    VMemberCreateContent
) {

    var VMemberCreatePanel = VBasePanel.extend({
        header: {
            title: "supervisor:member-add-title",
            subtitle: "supervisor:member-add-subtitle",
        },
        buttons: { back: 'close', },
        content: { create: VMemberCreateContent, },
        tabs: [{ id: 'create', active: true }],

        initialize: function(opt) {
            this.model = opt.model;
            this.selectedGroup = opt.selectedGroup;
            this.collection = new CGroups(null, { tree: true, tree_only: true, removeExpired: true });
            this.memberList = opt.memberList;
        },

        render: function() {
            VMemberCreatePanel.__super__.render.apply(this, arguments);
            this.collection.fetch();

            this.showEdit();

            if (this.view.create) {
              this.view.create.selectedGroup = this.selectedGroup;
              this.listenTo(this.view.create, 'member:created', this.onNewMember);
            }

            return this;
        },

        getContentViewOptions: function(options) {
            return _.extend({}, options, {
              model: this.model,
              collection: this.collection,
              selectedGroup: this.selectedGroup,
            });
        },

        showEdit: function() { return this.showContent('create'); },

        onNewMember: function(member) {
          this.memberList.addMember(member);
          UserEvents.newMemberAdded(member);
          if (_.isNull(User.get('_fallbackMemberId')) && User.get('isHiddenFromClientsList')) {
              User.set('_fallbackMemberId', member.id);
          }
          this.memberList.onMemberClick(member);
        }
    });

    return VMemberCreatePanel;
});

